import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="focus"
export default class extends Controller {
  connect() {
    this.element.select()  // Need to call select() instead of focus() for IE11.
  }
}
